import React from "react"
import './hamburgers.css'

export default class Hamburger extends React.Component {

    state = {
      active: false
    }

    toogleMenu = () => {
      this.setState({active: !this.state.active})
    }

    render() {

    const {active} = this.state

    const searchForm = <form action="/pretraga" accept-charset="UTF-8" method="get">
                          <input name="query" placeholder="Traži" type="text" />
                        </form>

    return (
      <div className="mobile_navigation">
        { active && <ul className={this.props.color}>
          <li><a href="/o-projektu">O PROJEKTU</a></li>
          <li><a href="/o-nama">O NAMA</a></li>
          <li><a href="/ukljucite-se">UKLJUČITE SE</a></li>
          <li><a href="/aktualnosti">AKTUALNOSTI</a></li>
          <li>{searchForm}</li>
        </ul>}
        <button className={active ? "hamburger hamburger--squeeze is-active" : "hamburger hamburger--squeeze"}
                aria-label="Menu" aria-controls="navigation"
                onClick={() => this.toogleMenu()}>
          <span className="hamburger-box">
            <span className="hamburger-inner"></span>
          </span>
        </button>
      </div>
    );
  }
}

/*
hamburger-types
  3dx,
  3dx-r,
  3dy,
  3dy-r,
  3dxy,
  3dxy-r,
  arrow,
  arrow-r,
  arrowalt,
  arrowalt-r,
  arrowturn,
  arrowturn-r,
  boring,
  collapse,
  collapse-r,
  elastic,
  elastic-r,
  emphatic,
  emphatic-r,
  minus,
  slider,
  slider-r,
  spring,
  spring-r,
  stand,
  stand-r,
  spin,
  spin-r,
  squeeze,
  vortex,
  vortex-r
  */



// WEBPACK FOOTER //
// app/frontend/components/Hamburger.js